import React, { useState, useEffect } from 'react';
import './App.css';
import { api } from './api';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import KundenListe from './pages/KundenListe';
import KundenDetail from './pages/KundenDetail';
import FahrzeugDetail from './pages/FahrzeugDetail';
import KontakteListe from './pages/KontakteListe';
import Einstellungen from './pages/Einstellungen';

export default function App() {
  const [user, setUser] = useState(null);
  const [authChecked, setAuthChecked] = useState(false);
  const [page, setPage] = useState({ name: 'dashboard' });

  useEffect(() => {
    const token = localStorage.getItem('fuhrpark_token');
    if (!token) { setAuthChecked(true); return; }
    api.getMe().then(u => { setUser(u); setAuthChecked(true); }).catch(() => {
      localStorage.removeItem('fuhrpark_token');
      setAuthChecked(true);
    });
  }, []);

  const handleLogin = (u) => setUser(u);

  const handleLogout = () => {
    const token = localStorage.getItem('fuhrpark_token');
    if (token) api.logout(token).catch(() => {});
    localStorage.removeItem('fuhrpark_token');
    setUser(null);
  };

  if (!authChecked) return <div className="spinner">Lade…</div>;
  if (!user) return <Login onLogin={handleLogin} />;

  const navigate = (name, params = {}) => setPage({ name, ...params });

  return (
    <div className="app">
      <nav className="navbar">
        <div className="nav-brand" onClick={() => navigate('dashboard')}>
          <img className="nav-logo" src="/Logo_Steiner_blau.gif" alt="Steiner" />
          <span className="nav-title">Fuhrparkverwaltung</span>
        </div>
        <div className="nav-links">
          <button className={`nav-link ${page.name === 'dashboard' ? 'active' : ''}`} onClick={() => navigate('dashboard')}>
            Dashboard
          </button>
          <button className={`nav-link ${page.name === 'kunden' || page.name === 'kunde-detail' ? 'active' : ''}`} onClick={() => navigate('kunden')}>
            Kunden
          </button>
          <button className={`nav-link ${page.name === 'fahrzeuge' ? 'active' : ''}`} onClick={() => navigate('fahrzeuge')}>
            Alle Fahrzeuge
          </button>
          <button className={`nav-link ${page.name === 'kontakte' ? 'active' : ''}`} onClick={() => navigate('kontakte')}>
            Kontaktbuch
          </button>
          <button className={`nav-link ${page.name === 'einstellungen' ? 'active' : ''}`} onClick={() => navigate('einstellungen')}>
            Einstellungen
          </button>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginLeft: 'auto', paddingLeft: 16 }}>
          <span style={{ fontSize: 13, color: 'rgba(255,255,255,.75)' }}>{user.name}</span>
          <button className="btn btn-sm" style={{ background: 'rgba(255,255,255,.15)', color: '#fff', border: '1px solid rgba(255,255,255,.25)' }} onClick={handleLogout}>Abmelden</button>
        </div>
      </nav>
      <main className="main">
        {page.name === 'dashboard' && <Dashboard navigate={navigate} />}
        {page.name === 'kunden' && <KundenListe navigate={navigate} />}
        {page.name === 'fahrzeuge' && <KundenDetail navigate={navigate} alleMode />}
        {page.name === 'kunde-detail' && <KundenDetail navigate={navigate} kundenId={page.kundenId} />}
        {page.name === 'fahrzeug-detail' && <FahrzeugDetail navigate={navigate} fahrzeugId={page.fahrzeugId} kundenId={page.kundenId} />}
        {page.name === 'kontakte' && <KontakteListe navigate={navigate} />}
        {page.name === 'einstellungen' && <Einstellungen user={user} />}
      </main>
    </div>
  );
}
